import React, { useEffect, useState } from 'react';
import styles from './HomePage.module.scss';
import clsx from 'clsx';
import Button from '../../components/Button/Button';
import SideBar from '../../components/SideBar/SideBar';
import LoginForm from '../../components/LoginForm/LoginForm';
import { ToastContainer } from 'react-toastify';
import Link from '../../components/Link/Link';
import { serviceList } from '../../redux/actions/service/serviceList';
import { useDispatch, useSelector } from 'react-redux';
import { imageUrl } from '../../utils/imageUrl';
import BannerBalls from '../../components/BannerBalls/BannerBalls';

export default function HomePage() {
  const [showLogin, setShowLogin] = useState(false);
  const [typeUser, setTypeUser] = useState('USER');
  const dispatch = useDispatch();
  const {
    serviceList: { data: serviceListData, loading: serviceListLoading, error: serviceListError },
  } = useSelector((state) => state.service);
  useEffect(() => {
    dispatch(serviceList());
  }, []);

  const handleClose = () => {
    setTypeUser(null);
    setShowLogin(false);
  };
  const links = [
    {
      name: 'Вход для партнеров',
      onClick: () => {
        setTypeUser('PARTNER');
        setShowLogin(true);
      },
    },
    {
      name: 'Сообщество',
      link: '#',
    },
    {
      name: 'Поддержка',
      link: '#',
    },
  ];
  return (
    <div className={clsx(styles.wrap)}>
      <ToastContainer theme="colored" />

      <div className={clsx(styles.header)}>
        <img src="/img/logo.png" alt="" className="logo" />
        <div className={clsx(styles.list)}>
          {links?.map((link) => (
            <Link
              onClick={() => {
                if (link?.link) {
                  window.open(link?.link, '_blank', 'noopener,noreferrer');
                } else {
                  link?.onClick();
                }
              }}>
              {link?.name}
            </Link>
          ))}
        </div>
        <Button
          className={clsx(styles.btnUser)}
          onClick={() => {
            setTypeUser('USER');
            setShowLogin(true);
          }}>
          Войти
        </Button>{' '}
      </div>
      <div className={clsx(styles.banner)}>
        <BannerBalls />
        <div className={clsx(styles.bannerTitle)}>Плати меньше, покупай больше</div>
        <div className={clsx(styles.bannerText)}>Сервис позволяет экономить на донатах в мобильные игры</div>
        <div className={clsx(styles.bannerContent)}>
          <img src="/img/g.png" alt="" className={clsx(styles.bannerLeft)} />
          <div className={clsx(styles.bannerCenter)}>
            <div className={clsx(styles.bannerBadge, styles.bannerBadge1)}>
              Первая строка <br /> вторая
            </div>
            <div className={clsx(styles.bannerBadge, styles.bannerBadge2)}>
              Это длинный текст для того <br /> чтобы показать
            </div>
            <div className={clsx(styles.bannerBadge, styles.bannerBadge3)}>
              Это уже нижний <br /> короткий{' '}
            </div>
            <div className={clsx(styles.bannerCircle)}>
              <div className={clsx(styles.bannerNumber)}>{10}</div>
              Пока не <br /> знаем когда
            </div>
          </div>
          <img src="/img/m.png" alt="" className={clsx(styles.bannerRight)} />
        </div>
      </div>
      <div className={clsx(styles.blockHide)}>
        <div className={clsx(styles.blockHideNumber)}>12</div>
        <div className={clsx(styles.blockHideTitle)}>Pre-Built Unique Demos</div>
        <div className={clsx(styles.blockHideText)}>
          Explore a collection of unique, ready-made website demos to kickstart your design journey. Import any design with one click, and easily align it with your branding using global fonts and colour settings. Start customizing with the Elementor page builder and update the content effortlessly.
        </div>
        <div className={clsx(styles.blockHideList)}>
          <div className={clsx(styles.blockHideItem)}>
            <div className={clsx(styles.blockHideItemIcon)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-award">
                <circle cx="12" cy="8" r="7"></circle>
                <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
              </svg>
            </div>
            <div className={clsx(styles.blockHideItemText)}>
              No Coding Skills <br /> Required
            </div>
          </div>{' '}
          <div className={clsx(styles.blockHideItem)}>
            <div className={clsx(styles.blockHideItemIcon)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-award">
                <circle cx="12" cy="8" r="7"></circle>
                <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
              </svg>
            </div>
            <div className={clsx(styles.blockHideItemText)}>
              First 6 Months of <br />
              Support Are Free
            </div>
          </div>{' '}
          <div className={clsx(styles.blockHideItem)}>
            <div className={clsx(styles.blockHideItemIcon)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-award">
                <circle cx="12" cy="8" r="7"></circle>
                <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
              </svg>
            </div>
            <div className={clsx(styles.blockHideItemText)}>
              Free Lifetime <br />
              Updates
            </div>
          </div>
        </div>
      </div>
      <div className={clsx(styles.partners)}>
        <div className={clsx(styles.partnersTitle)}>Партнеры</div>
        <div className={clsx(styles.partnerList)}>
          {serviceListData?.map((item) => (
            <div className={clsx(styles.partner)}>
              <img src={imageUrl(item?.logo)} alt="" className={clsx(styles.partnerLogo)} />
              <div className={clsx(styles.partnerTitle)}>{item?.name}</div>
              <Link
                className={clsx(styles.partnerLink)}
                onClick={() => {
                  let fullUrl = item?.site;

                  if (!fullUrl.startsWith('http://') && !fullUrl.startsWith('https://')) {
                    fullUrl = 'https://' + fullUrl; // По умолчанию https
                  }

                  window.open(fullUrl, '_blank', 'noopener,noreferrer');
                }}>
                {item?.site?.replace('https://', '')}
              </Link>
            </div>
          ))}
        </div>
      </div>
      <SideBar show={showLogin} onClose={handleClose}>
        <LoginForm type={typeUser} />
      </SideBar>
    </div>
  );
}
